import { useCallback, useMemo } from "react";
import { API_URL } from "../apiConfig";
import { adminHeaders, getAdminToken } from "../admin/adminApi";
import { bearerAuthHeaders, readAccessToken } from "../authTokenUtils";

function isOwnerStudioPath(path) {
  const p = path.startsWith("/") ? path : `/${path}`;
  if (p.startsWith("/builder/catalog/public")) return false;
  return (
    p.startsWith("/settings") ||
    p.startsWith("/builder/") ||
    p === "/products" ||
    p.startsWith("/products/") ||
    p.startsWith("/catalog-themes")
  );
}

export function useCatalogStudioApi(editorMode, adminStudioUserId = "") {
  const merchantToken = readAccessToken();
  const adminToken = getAdminToken();
  const isAdminStudio = Boolean(editorMode && adminStudioUserId && adminToken);

  const headers = useMemo(() => {
    if (isAdminStudio) return adminHeaders();
    return bearerAuthHeaders().headers || {};
  }, [isAdminStudio, merchantToken, adminToken]);

  const authHeader = useMemo(
    () => (isAdminStudio ? { headers } : bearerAuthHeaders()),
    [isAdminStudio, headers, merchantToken]
  );

  const url = useCallback(
    (path) => {
      const p = path.startsWith("/") ? path : `/${path}`;
      if (isAdminStudio && isOwnerStudioPath(p)) {
        return `${API_URL}/admin/users/${adminStudioUserId}/studio${p}`;
      }
      return `${API_URL}${p}`;
    },
    [isAdminStudio, adminStudioUserId]
  );

  const canEdit = Boolean(editorMode && (merchantToken || isAdminStudio));

  return { authHeader, url, canEdit, isAdminStudio, headers };
}
